import { render, staticRenderFns } from "./AiAdmin.vue?vue&type=template&id=4bc4f795&scoped=true"
import script from "./AiAdmin.vue?vue&type=script&lang=js"
export * from "./AiAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc4f795",
  null
  
)

export default component.exports